import useStateFromProp from './useStateFromProp';

export default useStateFromProp;
